// Client de `POST /backoffice/wizard/sessions/summaries`: resumen de varias sesiones por id.
import { apiFetch } from '../../../client';
import type {
    SessionSummariesApi,
    SessionSummariesRequest,
    WizardSessionSummariesResponse,
    WizardSessionSummary,
} from './sessionSummariesContract';

const BASE_URL = import.meta.env.VITE_API_RETAIL_WIZARD_BASE_URL;

export const SESSION_SUMMARIES_PATH = '/backoffice/wizard/sessions/summaries';

/** Tope de ids por pedido que acepta el endpoint. */
export const SESSION_SUMMARIES_BATCH = 50;

async function fetchBatch(sessionIds: string[]): Promise<WizardSessionSummary[]> {
    const request: SessionSummariesRequest = { sessionIds };
    const body = await apiFetch<WizardSessionSummariesResponse>(SESSION_SUMMARIES_PATH, {
        baseUrl: BASE_URL,
        method: 'POST',
        body: JSON.stringify(request),
    });
    return body.sessions;
}

export const sessionSummariesClient: SessionSummariesApi = {
    async getSummaries(sessionIds) {
        const batches: string[][] = [];
        for (let i = 0; i < sessionIds.length; i += SESSION_SUMMARIES_BATCH) {
            batches.push(sessionIds.slice(i, i + SESSION_SUMMARIES_BATCH));
        }
        const pages = await Promise.all(batches.map(fetchBatch));
        return pages.flat();
    },
};
